import { useEffect, useState } from 'react';
import { StakeholderValueAllocation } from 'sched';
import { useDatabase } from './useDatabase';

export interface StakeholderDetails {
  id: string;
  name: string;
  description: string | undefined;
  valueAllocations: StakeholderValueAllocation[];
  representativeIds: string[];
}

export function useStakeholder(stakeholderId: string | undefined) {
  const { database, loading: databaseLoading } = useDatabase();
  const [stakeholder, setStakeholder] = useState<StakeholderDetails | null>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    if (!database || !stakeholderId) {
      if (!database) setLoading(false);
      return;
    }

    try {
      const stakeholders = database.stakeholders();
      const obj = stakeholders[stakeholderId];

      if (!obj) {
        setError(`Stakeholder with ID ${stakeholderId} not found`);
        setStakeholder(null);
      } else {
        setStakeholder({
          id: stakeholderId,
          name: obj.name(),
          description: obj.description() ?? undefined,
          valueAllocations: database.value_allocations_for_stakeholder(stakeholderId),
          representativeIds: database.representatives_for_stakeholder(stakeholderId),
        });
        setError(null);
      }
    } catch (err) {
      console.error('Error fetching stakeholder:', err);
      setError(`Error fetching stakeholder: ${err}`);
      setStakeholder(null);
    } finally {
      setLoading(false);
    }
  }, [database, stakeholderId]);

  return { stakeholder, loading: loading || databaseLoading, error };
}
